import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sorter",
  "use": "sorter-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol viewBox=\"0 0 10 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sorter\">\n    <path opacity=\"0.3\" d=\"M1 1.5L5 5.5L9 1.5\" stroke=\"inherit\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol